export enum StatisticsGroupingType {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly',
}
